import _ from "lodash";
import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import LabelValuePair from '../Common/LabelValuePair';
import { checkForAPISuccess, convertCamelCaseToNormalCase, showErrorToast, showSuccessToast } from "../../../Common/commonFunctions"
import ToolTip from "../Common/Tooltip";
import { Button, Modal } from "react-bootstrap";
import { removeBearingByLocationAndComponentId } from '../../../api/index';
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { REMOVE_BEARING } from "../../../store/actions";
import { ClipLoader } from 'react-spinners';

const BearingList = props => {

    const dispatch = useDispatch();

    const [utils, setUtils] = useState({
        indexOfVisibleBearingInfo: undefined,
        bearingInRemove: {}
    });

    const expandBearingInfoBasedOnIndex = (index) =>
        setUtils({...utils, indexOfVisibleBearingInfo : utils.indexOfVisibleBearingInfo === index ? undefined : index});

    const returnLabelValuePair = (label, value, handleChange) => 
        <LabelValuePair
            label={convertCamelCaseToNormalCase(`${label}`)}
            value={value}
            viewMode={true}
            handleChange={handleChange}
        />

    const setBearingToBeRemoved = (loation) => setUtils({ ...utils, bearingInRemove: { componentId: props?.componentId, location: loation } });

    const removeBearing = async () => {
        const { data } = await removeBearingByLocationAndComponentId(utils.bearingInRemove);
        return data;
    }

    const removeBearingMutation = useMutation(removeBearing);

    useEffect(() => {
        if(removeBearingMutation.isSuccess) {
            if(checkForAPISuccess(removeBearingMutation?.data?.statusCode)) {
                dispatch({ type: REMOVE_BEARING, payload: utils.bearingInRemove.location });
                setUtils({ ...utils, bearingInRemove: {} });
                showSuccessToast("Bearing removed successfully.")
            }
            else {
                showErrorToast("Failed to remove bearing.");
            }
        }
    }, [removeBearingMutation.isSuccess])

    return (
        <>
            <Modal
                onHide={() => setUtils({ ...utils, bearingInRemove: {} })}
                show={!_.isEmpty(utils.bearingInRemove?.componentId)}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <h5>
                        <b>Remove bearing</b>
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <center className="my-5">
                        {
                            removeBearingMutation.isLoading ?
                                <ClipLoader color="#075978" />
                                    :
                                <b>Are you sure you want to remove the bearing?</b>
                        }
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={removeBearingMutation.isLoading}
                        onClick={() => setUtils({ ...utils, bearingInRemove: {} })}
                        className="secondary-button"
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={removeBearingMutation.isLoading}
                        onClick={() => removeBearingMutation.mutate()}
                    >
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                !_.isEmpty(props?.bearings) ?
                    props?.bearings?.map((bearing, index) =>
                        <>
                            {
                                <div className="flex-space-even my-1">
                                    <div className="cursor-pointer" onClick={() => expandBearingInfoBasedOnIndex(index)}>
                                        <Icon icon={`bi:caret-${utils.indexOfVisibleBearingInfo === index ? "down" : "right"}-fill`} /> 
                                        <span style={{ fontWeight: "bold", marginLeft: "2px" }}>{bearing.location}</span>
                                        {
                                            utils.indexOfVisibleBearingInfo !== index &&
                                                <>
                                                    : {bearing.bearingNumber || bearing.bearingType}
                                                </>
                                        }
                                    </div>
                                    <ToolTip
                                        toolTipKEy={"remove-bearing"}
                                        toolTipValue={"Remove bearing"}
                                        overlayComponent={
                                            <Icon
                                                icon="feather-minus-circle"
                                                className="cursor-pointer mr-3 p-0"
                                                onClick={() => setBearingToBeRemoved(bearing.location)}
                                            />
                                        }
                                    />
                                </div>
                            }
                            {
                                (utils.indexOfVisibleBearingInfo === index) && Object.entries(bearing).map(([key, value]) => (
                                        returnLabelValuePair(key, value)
                                    )
                                )
                            }
                        </>
                    )
                        :
                    <center className="p-2 font-weight-bold">NO BEARINGS FOUND</center>
            }
        </>
    );
}

export default BearingList;